import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import ConfirmDialog from "@/components/utils/ui_v4/alerts/confirm/ConfirmDialog.vue"; // Certifique-se que o caminho está correto

const showConfirm = ({ title, message, button = {}, callback }) => {
  const mountNode = document.createElement('div')
  document.body.appendChild(mountNode)

  const vm = new Vue({
    vuetify,
    data() {
      return {
        visible: false,
        // TRAVA DE SEGURANÇA: Garante que o callback rode apenas 1 vez
        isResolved: false
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.visible = true
      })
    },
    methods: {
      destroy() {
        setTimeout(() => {
          this.$destroy()
          if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el)
          }
        }, 300)
      },

      // Centraliza a finalização
      resolve(value) {
        // Se já foi resolvido (por clique ou por fechamento), ignora
        if (this.isResolved) return

        this.isResolved = true
        this.visible = false

        if (typeof callback === 'function') {
          callback(value)
        }

        this.destroy()
      }
    },
    render(h) {
      return h(ConfirmDialog, {
        props: {
          isOpen: this.visible,
          title,
          message,
          buttonYes: button.yes,
          buttonNo: button.no
        },
        on: {
          confirm: () => this.resolve(true),
          cancel: () => this.resolve(false),

          // Se o dialog fechar por clique fora (backdrop) ou ESC
          'update:isOpen': (val) => {
            if (!val) this.resolve(false)
          }
        }
      })
    }
  })

  vm.$mount(mountNode)
}

export default showConfirm
